// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4580":"1834f72f","7744":"1834f72f"}[chunkId] + ".chunk.css";
};